module.exports = __webpack_public_path__ + "03_glasses_brown.4cf0434f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer4/03_glasses_brown.png
// module id = b5aT
// module chunks = 0